<div class="row">
  <div class="col-lg-5 col-md-6 col-sm-12 mx-auto">
    <div class="bg-white d-flex flex-column overflow-hidden p-4 rounded-5">
      <h2 class="text-primary fw-500 mb-2">Get started With Treasure Hill</h2>
      <p class="text-muted">Please fill the one time registration form to get started.</p>
      <!-- Public app: reCAPTCHA enabled (default behavior) -->
      <div class="flex-fill me-n2 overflow-y-auto pe-2 mxh-500">
        <lib-realtor-form
          [isPublic]="'public'"
          [enableRecaptcha]="true"
          [onSubmit]="onSubmitButtonClickObservable"
        ></lib-realtor-form>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button
          class="btn btn-shadow text-center btn-h45 btn-prosp-submit justify-content-center"
          [routerLink]="['/new', salesOfficeId(), 'public']"
        >
          Back
        </button>
        <button
          class="btn btn-primary text-center btn-h45 btn-prosp-submit justify-content-center"
          (click)="onSaveButtonClick()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
